import { render } from "./DialogCustomerComplex.vue?vue&type=template&id=6f29e402"
import script from "./DialogCustomerComplex.vue?vue&type=script&lang=js"
export * from "./DialogCustomerComplex.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__